import { Dispatch } from "redux";
import { resources } from "@constants/hardcoded-strings";
import { AxnCompany, AxnRelyingParty } from "@idw-types/data/reference-data/axn";
import { createWorkflowRequest } from "@requests/service-configuration";
import { displaySuccessModal, logAndDisplayErrorModal } from "@utils/app-alert-util";
import { getWorkflowConfigurationsReduxRequest } from "./get-workflow-configurations";
import { generateImportErrorMessages } from "@utils/entity-import/entity-import-util";
import { EntityImportValidationError } from "@idw-types/data/entity-import-validation-error";

export const createWorkflowReduxRequest = (dispatch: Dispatch) => async (
    workflowName: string,
    workflowID: string,
    workflowTemplateID: string,
    workflowJSON: { [key: string]: any },
    relyingPartyID: string,
    rpServiceRedirects: Array<string>,
    axnCompanies: Array<AxnCompany>,
    axnRelyingParties: Array<AxnRelyingParty>
) => {
    const { data, error, body } = await createWorkflowRequest(
        workflowName,
        workflowID,
        workflowTemplateID,
        workflowJSON,
        relyingPartyID,
        rpServiceRedirects
    );
    if (data) {
        await getWorkflowConfigurationsReduxRequest(dispatch)(axnCompanies, axnRelyingParties);
        displaySuccessModal(
            dispatch,
            resources.requests.createWorkflow.success.title,
            resources.requests.createWorkflow.success.message
        );
        return data;
    } else {
        let detailedMessage: string = null;
        if (error) {
            try {
                const parsedError = JSON.parse(error);

                const testString = "Unable to copy Workflow: Invalid workflow configuration: ";

                if (parsedError && (parsedError.message as string).includes(testString)) {
                    const errorJSON = parsedError.message.split(testString)[1];

                    const parsedJSON = JSON.parse(errorJSON) as { [key: string]: Array<EntityImportValidationError> };

                    const serviceErrorMessages: Array<string> = [];
                    Object.keys(parsedJSON).forEach((serviceId) => {
                        const serviceErrorList = generateImportErrorMessages(parsedJSON[serviceId]);
                        serviceErrorMessages.push(...serviceErrorList);
                    });

                    if (serviceErrorMessages.length > 0) {
                        detailedMessage = JSON.stringify({
                            message: serviceErrorMessages.join("\n ")
                        });
                    }
                }
            } catch (err) {
                console.error(err);
            }
        }

        logAndDisplayErrorModal(
            dispatch,
            error,
            resources.requests.createWorkflow.error.title,
            resources.requests.createWorkflow.error.message,
            detailedMessage,
            null,
            body
        );
    }

    return null;
};